import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { BiMinus,BiPlus } from "react-icons/bi";
function CollapseDivWrapper(props) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if(props.open){
            setOpen(true)
        }
    }, [props.open]);
    return (
       
            <Card>
                <Card.Header onClick={()=>setOpen(!open)} className='justify-content-between pointer d-flex align-items-center'>{props?.title}  {open  ? <BiMinus onClick={()=>setOpen(false)} className='pointer' /> : <BiPlus onClick={()=>setOpen(true)} className='pointer' />} </Card.Header>
                <Collapse in={open}>
                    <div>
                    <Card.Body>
                        {props.children}
                    </Card.Body>
                    </div>
                </Collapse>

            </Card>
       
    );
}

export default CollapseDivWrapper;